import React, { useState } from "react";
import { submitCifOffer } from "@/api/placeOffer";
import { acknowledgementStatement } from "@/setting";
import { BsCheckCircleFill } from "react-icons/bs";
import { isValidSession } from "@/api/auth";
import { batch, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";

const Submit = ({ cifFormetails, accordionState, cifId, setCifCompleted,setIsFromCif , buyerAgentState}) => {
  const [acknowledgement, setAcknowledgement] = useState(false);
  const [acknowledgementError, setAcknowledgementError] = useState("");
  const [loading,setLoading] = useState(false)
  const dispatch = useDispatch();

  const handleCheckboxChange = (event) => {
    setAcknowledgement(event.target.checked);
     setAcknowledgementError("")
  };

  const submitDetails = async () => {
    try {
       if (!acknowledgement) {
        setAcknowledgementError("Please accept the declaration");
        return;
      }
           setLoading(true)

      
      const defaultCoBuyer = {
        firstName: "",
        lastName: "",
        email: "",
        middleInitials: "",
        phone: "",
        company: "",
        address1: "",
        address2: "",
        city: "",
        stateId: "",
        zip: "",
      };
      const payload = {
        buyer: cifFormetails.buyer,
        coBuyer:
          (cifFormetails?.coBuyer && Object?.getOwnPropertyNames(cifFormetails?.coBuyer).length === 0)
            ? defaultCoBuyer
            : cifFormetails.coBuyer,
        buyerAgent: buyerAgentState
          ? cifFormetails.buyerAgent
          : defaultCoBuyer,

        closingAgent: {
          firstName: "",
          email: "",
          company: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
        },
        titleProvider: {
          firstName: "",
          email: "",
          company: "",
          phone: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          zip: "",
        },
        closingInfoChoice: "",
        userRole: cifFormetails.userRole,
      };      
      // console.log("paylaod",payload)
           const isSessionValid = await isValidSession();
                    const isValid = isSessionValid.data?.isValidSession;
                if (isValid === "Y"){
      const data = await submitCifOffer({ cifId: cifId, payload: payload });
      if (data.data.status === "SUCCESS") {
        setLoading(false);
        setCifCompleted(true);
        setIsFromCif(true)
      }else{
        console.log(data);
       setLoading(false)
      }
    }else{
      toast.error("current session not valid, Please login again");
              batch(() => {          
                dispatch(setLoginModal(true));
                dispatch(setLoginTab("loginTab"));
                dispatch(setLoginCallLocation("Popup"));
              });
               setLoading(false);
    }
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  };

  return (
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header p-1" id="flush-headingFive">
        <div
          className={`accordion-button ${
            accordionState?.accordion5?.close ? "collapsed" : ""
          }`}
          // type="button"
          // data-bs-toggle="collapse"
          // data-bs-target="#flush-collapseFive"
          // aria-expanded="false"
          id="acc5"
          // aria-controls="flush-collapseFive"
          disabled={accordionState?.accordion5?.close}
        >
          <div className="d-flex justify-content-between w-100">
                   <p className="mb-0 responsive-heading">
                     {accordionState?.accordion5?.visited ? (
                       <BsCheckCircleFill className="icon_bid me-2" size={30} />
                     ) : (
                       <BsCheckCircleFill className="text-dark me-2" size={30} />
                     )}
          Submit
          </p></div>
        </div>
      </h2>

      <div
        id="flush-collapseFive"
        className={`accordion-collapse collapse ${
          accordionState?.accordion5?.close ? "" : "show"
        }`}
        aria-labelledby="flush-headingFive"
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body ml35">
          <p className="d-flex ">
            <input
              type="checkbox"
              name="acknowledgement"
              id="acknowledgement"
              className="form-check-input"
              onChange={handleCheckboxChange}
              checked={acknowledgement || false}
            />
            <label className="form-check-label mx-1 acknowldegement-pof-offer" for="acknowledgement">
              {acknowledgementStatement}
            </label>
          </p>
{acknowledgementError?.length > 0 && (
        <p className="error-message-offer">{acknowledgementError}</p>
      )}
          <button
            type="submit"
            className="continue-button"
            onClick={submitDetails}
            disabled={loading}
            // disabled={!acknowledgement}
          >
            {loading?"Submitting...":"Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Submit;
